<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import ExpandBtn from '@/components/common/ExpandBtn.vue'
import OverviewCard from '@/components/overview/OverviewCard.vue'

const props = defineProps({
  drawerWidth: {
    type: String,
    required: true
  },
  expand: {
    type: Boolean,
    default: false
  }
})

const store = useStore()

const showOverview = computed(() => store.state.dikeProfiles.showOverview)

const expandState = computed({
  get: () => props.expand,
  set: (value) => emit('toggleExpand', value)
})

const emit = defineEmits(['toggleExpand'])
</script>
<template>
  <v-navigation-drawer
    v-if="showOverview"
    location="right"
    :style="{ width: drawerWidth, transition: 'none' }"
  >
    <ExpandBtn v-model="expandState" />
    <OverviewCard />
  </v-navigation-drawer>
</template>
